import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authForgotPassword } from '../services/api';

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setStatus('Please enter your email address.');
      return;
    }

    try {
      setLoading(true);
      setStatus('Sending reset link…');
      const callbackUrl = `${window.location.origin}/reset-password`;
      await authForgotPassword({ email: trimmedEmail, callbackUrl });
      setStatus('If an account exists, a password reset link has been sent to your email.');
      setEmail('');
    } catch (err) {
      setStatus(err.message || 'Unable to send reset link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="card auth-card">
        <div className="auth-step-badge">STEP 0 · SECURE SIGN-IN</div>

        

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label>Email address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
            />
          </div>

          <button className="btn btn-primary auth-submit" type="submit" disabled={loading}>
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
        <div className="form-group"> 
          <button  type="button" className="btn btn-primary auth-submit" onClick={() => navigate('/auth')}>
             Log in
          </button>
        </div>

        {status && <div className={`status ${status.includes('Unable') || status.includes('Please') ? 'error' : ''}`}>{status}</div>}
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
